module.exports = __webpack_public_path__ + "media/flow-icon.7fa3e9b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/flow-icon.svg
// module id = 294
// module chunks = 0